import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { VrrButton, VrrCircleLoader, VrrTable } from '../../shared_components';
import BrandsModal from './brands_modal';
import { prepareBody, prepareHeader } from './services';
import { getBrands } from '../../../redux/app/appActions';
import { manageBrands } from '../../../redux/userProfile/userProfileActions';
import { TBrandsAPI } from '../../shared_components/vrr_dropdown/types';
import './ConnectedBrand.scss';

const ConnectedBrand: React.FC = () => {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const brands = useSelector(getBrands);
  const [openBrandModal, setOpenBrandModal] = useState(false);

  const closeModal = () => {
    setOpenBrandModal(false);
  };

  const onSubmit = (newBrands: TBrandsAPI[]) => {
    const toHide: string[] = [];
    const toDisplay: string[] = [];
    newBrands.forEach((brand) => {
      if (
        brand.status === 'hidden' &&
        !toHide.includes(brand.brand_id.toString())
      ) {
        toHide.push(brand.brand_id.toString());
      } else if (!toDisplay.includes(brand.brand_id.toString())) {
        toDisplay.push(brand.brand_id.toString());
      }
    });
    dispatch(
      manageBrands({
        toHideBrands: toHide,
        toDisplayBrands: toDisplay
      })
    );
    closeModal();
  };

  return (
    <div className="connected-brand">
      <h4>{t('connected_brand.title')}</h4>
      <VrrCircleLoader isEnable={!brands?.length}>
        {!!brands?.length && (
          <>
            <VrrButton
              className="manage-brand"
              data-cy-id="user-profile-manage-brand-button"
              onClick={() => {
                setOpenBrandModal(true);
              }}
            >
              {t('connected_brand.title')}
            </VrrButton>
            <VrrTable
              header={prepareHeader()}
              body={prepareBody(brands)}
              tableProps={{
                borderless: true,
                striped: true,
                className: 'brand-table'
              }}
            />
          </>
        )}
      </VrrCircleLoader>
      <BrandsModal
        isOpen={openBrandModal}
        onCancelAction={closeModal}
        onSubmitAction={onSubmit}
      />
    </div>
  );
};

export default ConnectedBrand;
